module.exports = __webpack_public_path__ + "img/acente.86206f08.png";